"use client";
import {
  GET_PRODUCT_APPLICATION,
  IMAGES,
  LOGIN_SCHEMA,
  PRODUCTS,
  STAGE,
  STAGE_BASED_ROUTING,
  SUB_STAGE_FAILS,
  WEB_EVENTS,
} from "@/lib/constants";
import {
  ApplicationConfigWrapper,
  LoaderComponent,
  ModalComponent,
  PincodeValidation,
  SnackbarComponent,
} from "@/components";
import {
  useGenerateOtpMutation,
  useGetApplicationQuery,
  useVerifyOtpMutation,
} from "@/lib/redux";
import { useFormik } from "formik";
import LeftCard from "./left-card";
import { v4 as uuidv4 } from "uuid";
import RightCard from "./right-card";
import {
  FormHelperText,
  Grid,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  Stack,
} from "@mui/material";
import styles from "../personal-loan-landing.module.css";
import moengage from "@moengage/web-sdk";
import { useRouter } from "@/i18n/routing";
// import VerifyOtpModalFields from "./login-modal-fields";
import { sendEventAnalytics } from "@/lib/hooks/eventAnalytics";
import React, { useContext, useEffect, useState } from "react";
import FaceVerificationModal from "../../product-screens/kyc/face-verification/face-verification-modal";
import useOtpTimer from "@/lib/hooks/otpTimerHandler";
import {
  losApi,
  useGetApplicationConfigQuery,
  useGetCustomerQuery,
  usePostUtmDetailsMutation,
  useSetMarketingDataMutation,
} from "@/lib/redux/apis/los-api";
import { useTranslations } from "next-intl";
import { clientId, sessionId } from "@/lib/Firebase";
import { useDispatch } from "react-redux";
import Image from "next/image";
import VerifyOtpModalFields from "./login-modal-fields";
import LandingPageContext from "../context/landingContext";
import GetStarted from "../get-started";

const initialValue = {
  phone: "",
  terms: false,
  whatsapp: true,
};

const SignupSection = ({ params, afUserId, fbparams }) => {
  const t = useTranslations("Login");
  const router = useRouter();
  const dispatch = useDispatch();
  //STATES
  const [token, setToken] = useState(null);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [openPincodeModal, setOpenPincodeModal] = useState(false);
  const { timeLeft, startTimer, resetTimer } = useOtpTimer(60);
  const [showErrorFaceMatchModal, setShowErrorFaceMatchModal] = useState(false);
  const [maintenanceModalVisible, setMaintenanceModalVisible] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { isDrawerOpen, setIsDrawerOpen } = useContext(LandingPageContext);
  const [isresumeJourneyOpen, setIsResumeJourneyOpen] = useState(false);
  const [showModalContent, setShowModalContent] = useState({
    label:
      "We would love to serve you in the future, you can re-apply after 30 days.",
    subLabel: "Sorry! Please try later",
    buttonLabel: "OK",
    icon: IMAGES.faceNotVerified,
  });
  //APIS
  const [
    generateOtp,
    {
      isLoading: otpGenerating,
      isError: otpNotGenerated,
      isSuccess: otpGenerated,
      error: generateError,
    },
  ] = useGenerateOtpMutation();
  const [
    verifyOtp,
    {
      data: userData,
      isLoading: otpVerifying,
      isError: verificationError,
      isSuccess: verificationSuccess,
      error: verificationFailedReason,
      reset: resetVerifyOtp,
    },
  ] = useVerifyOtpMutation();
  const {
    data: customerData,
    isLoading: fetchingCustomerData,
    isSuccess: customerDatafetched,
  } = useGetCustomerQuery("", {
    skip: !token,
  });
  const {
    data: applicationData,
    isLoading: fetchingApplications,
    error: applicationFetchError,
  } = useGetApplicationQuery("", {
    skip: !token || !customerDatafetched,
  });
  const {
    data: applicationConfigData,
    isFetching,
    refetch: refetchApplicationConfigData,
  } = useGetApplicationConfigQuery();

  const [
    postMarketingParams,
    { data: marketingResponse, error: marketingError },
  ] = useSetMarketingDataMutation();
  const serverConfig = applicationConfigData?.data?.serverconfig;

  useEffect(() => {
    if (serverConfig) setMaintenanceModalVisible(serverConfig?.isServerDown);
  }, [serverConfig?.isServerDown]);

  const [postUtmParams, { data: utmResponse, error: utmError }] =
    usePostUtmDetailsMutation();

  //FORMIK
  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: LOGIN_SCHEMA,
    onSubmit: async ({ phone, terms, whatsapp }) => {
      // await moengage.identifyUser(`${phone?.replace("+91", "")}`);
      // moengage.setMobileNumber(`${phone?.replace("+91", "")}`);
      sendEventAnalytics({
        eventName: WEB_EVENTS.ON_LOGIN_SCREEN,
        phone,
      });
      resetVerifyOtp(); // Targeted reset of verificationFailedReason
      generateOtp({ phone, terms, whatsapp });
    },
  });

  const productApplication = GET_PRODUCT_APPLICATION(
    PRODUCTS.PL,
    applicationData?.data,
  );
  const isLoading =
    otpVerifying ||
    otpGenerating ||
    fetchingCustomerData ||
    fetchingApplications;
  const isError = otpNotGenerated || verificationError || applicationFetchError;
  const errorMessage =
    generateError?.data?.message || verificationFailedReason?.data?.message;
  //FUNCTIONS
  const handleFieldChange = (e, regex) => {
    if (regex(e.target.value)) {
      formik.handleChange(e);
    }
  };
  const handleOtpModal = () => {
    setOpenOtpModal(false);
    resetTimer();
  };

  const handleOtpSubmit = async (otp) => {
    AF("pba", "setCustomerUserId", formik.values.phone);
    await verifyOtp({ phone: formik.values.phone, otp });
  };

  const handleRouting = () => {
    router.replace(STAGE_BASED_ROUTING(applicationData?.data?.stage));
  };

  // EFFECTS
  useEffect(() => {
    if (otpGenerated) {
      setOpenOtpModal(true);
      startTimer();
    }
  }, [otpGenerated]);
  // dispaly errors
  useEffect(() => {
    if (isError) {
      SnackbarComponent({
        error: isError,
        errorMessage: errorMessage,
      });
    }
  }, [isError, errorMessage]);
  // Successfull handling of OTP
  useEffect(() => {
    const handleToken = async () => {
      if (userData?.data?.access_token) {
        sessionStorage.token = userData?.data?.access_token;
        const requestData = {
          gaSessionId: sessionId,
          firebaseInstanceId: clientId,
          appsflyerId: afUserId,
          advertisingId: "",
          idfv: "",
          cuid: `${formik.values?.phone}`,
          deviceType: "web",
          deviceId: uuidv4(),
          deviceName: `${window?.navigator?.userAgent}`,
          gaSessionId: sessionId,
        };
        postMarketingParams(requestData);
        SnackbarComponent({
          success: verificationSuccess,
          successMessage: userData?.message,
        });
        setToken(userData?.data?.access_token);
        await moengage.identifyUser(`${phone?.replace("+91", "")}`);
        moengage.setMobileNumber(`${phone?.replace("+91", "")}`);
      }
    };
    handleToken();
  }, [verificationSuccess, userData?.data?.access_token]);

  //Successfull handling of OTP
  useEffect(() => {
    if (userData?.data?.access_token) {
      const isApplicationClosedOrFailed =
        productApplication?.stage !== undefined &&
        (productApplication?.stage === STAGE?.CLOSED ||
          productApplication?.stage === STAGE?.CREDIT_QUEUE ||
          SUB_STAGE_FAILS.includes(productApplication?.subStage));

      if (isApplicationClosedOrFailed) {
        setOpenOtpModal(false);
        setShowErrorFaceMatchModal(true);
        setShowModalContent({
          label:
            productApplication?.loanApplyDate !== null
              ? `Sorry! We are unable to continue your loan application. Please re-apply on ${productApplication?.loanApplyDate}`
              : productApplication?.stage === "CREDIT_QUEUE"
                ? "Application Under Review"
                : "Sorry! We would love to serve you in the future, Please Try again Later.",
          subLabel:
            productApplication?.loanApplyDate !== null
              ? ""
              : productApplication?.stage === "CREDIT_QUEUE"
                ? "Your loan application is under evaluation. Please check after some time."
                : "Please try again later",
          buttonLabel: "OK",
          icon: IMAGES.rejectedLoan,
        });
        return;
      } else {
        router.replace(STAGE_BASED_ROUTING("RESUME_JOURNEY"));
      }
      sendEventAnalytics({
        eventName: WEB_EVENTS.SIGNIN_COMPLETED,
        ...customerData?.data,
        ...productApplication,
        utm: fbparams?.source ? fbparams : null,
      });
    }
  }, [applicationData, productApplication]);
  return (
    <Stack className={styles["landing-screen"]}>
      <LoaderComponent open={isLoading} />
      <ApplicationConfigWrapper
        open={maintenanceModalVisible}
        route={handleRouting}
        serverConfig={serverConfig}
      />

      <Grid
        container
        sx={{
          p: { xs: 2, md: 6 },
        }}
        justifyContent={"space-between"}
      >
        <Grid item>
          <Image
            src={IMAGES.heroFincorpDark}
            alt="Banner"
            priority={true}
            style={{ cursor: "pointer" }}
            width={isMobile ? 100 : "100%"}
            onClick={() =>
              (window.location.href = "https://www.herofincorp.com")
            }
          />
        </Grid>

        {isMobile && (
          <Grid item>
            <Image
              src={IMAGES.notificationButton}
              alt="Banner"
              priority={true}
              style={{ cursor: "pointer" }}
              onClick={() => setIsDrawerOpen(!isDrawerOpen)}
            />
          </Grid>
        )}
      </Grid>
      <Grid container pt={4}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <LeftCard />
        </Grid>
        <Grid
          // borderRadius={{
          //   lg: 0,
          //   md: 0,
          //   sm: "20px 20px 0px 0px",
          //   xs: "20px 20px 0px 0px",
          // }}
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          minWidth={"360px"}
          sx={{ pt: { xs: 3, md: 0 } }}
        >
          <RightCard
            formik={formik}
            isError={isError} //{isError}
            errorMessage={errorMessage}
            handleFieldChange={handleFieldChange}
            resumeJourney={isresumeJourneyOpen}
            handleResumeJourney={setIsResumeJourneyOpen}
          />
        </Grid>
      </Grid>
      <ModalComponent
        title={"Mobile Verification"}
        open={openOtpModal}
        handleModal={handleOtpModal}
        style={{ textAlign: "center" }}
      >
        <VerifyOtpModalFields
          formik={formik}
          timeLeft={timeLeft}
          resetTimer={resetTimer}
          generateOtp={generateOtp}
          otpVerifying={otpVerifying}
          handleOtpSubmit={handleOtpSubmit}
          verificationFailedReason={verificationFailedReason}
        />
      </ModalComponent>

      <ModalComponent
        open={isresumeJourneyOpen}
        handleModal={setIsResumeJourneyOpen}
        style={{ textAlign: "center" }}
      >
        <GetStarted
          formik={formik}
          isError={false} //{isError}
          errorMessage={"none"}
          handleFieldChange={handleFieldChange}
        />
      </ModalComponent>
    </Stack>
  );
};

export default SignupSection;
